module.exports = __webpack_public_path__ + "img/emoji-bomb-240x240.5059da87.png";